export const ADD_NEW_TEAM_TO_PANEL_LIST = 'ADD_NEW_TEAM_TO_PANEL_LIST';

export const ADD_SELECTED_TEAMS_TO_PANEL = 'ADD_SELECTED_TEAMS_TO_PANEL';

export const DELETE_TEAM_FROM_ADD_TO_PANEL_LIST = 'DELETE_TEAM_FROM_ADD_TO_PANEL_LIST';

export const RESET_TEAMS_ADD_TO_PANEL_LIST = 'RESET_TEAMS_ADD_TO_PANEL_LIST';
